// import React, { useEffect, useState } from 'react';
// import { UserSwitchOutlined } from '@ant-design/icons';
// import { useAuthContext } from '../../components/AuthProvider'; // Adjust path
// import { usePosOperatorShop } from '../../components/api/usePosOperatorShopid'; 
// import { useTillContext } from '../../components/tillContext'; // Adjust path
// import { useNavigate } from 'react-router-dom';
// import { Select, message, Spin, Form } from 'antd';
// import 'antd/dist/reset.css'; // For Ant Design v5
// import tobImage from '../../assets/images/top-header.png';

// function RolePosTopbar() {
//   const { handleLogoutUser, token, loginRole, userId } = useAuthContext();
//   const { shops, selectedShop, selectShop, loading: shopLoading, error: shopError } = usePosOperatorShop();
//   const { tills, selectedTill, selectTill, loading: tillLoading, error: tillError } = useTillContext();
//   const navigate = useNavigate();
//   const [form] = Form.useForm();
//   const isPosOperator = loginRole.includes('POS Operator');

//   // Handle errors
//   useEffect(() => {
//     if (shopError) {
//       message.error(`Failed to fetch shops: ${shopError}`);
//     }
//     if (tillError) {
//       // message.error(`Failed to fetch tills: ${tillError}`);
//     }
//     // Log businessId for debugging
//     console.log('Selected Shop:', selectedShop);
//     console.log('Selected Shop businessId:', selectedShop?.businessId || 'Not available');
//   }, [shopError, tillError, selectedShop]);

//   // Handle shop selection
//   const handleShopSelect = (shopId) => {
//     console.log('Selecting shop with ID:', shopId);
//     selectShop(shopId);
//   };

//   // Handle till selection
//   const handleTillSelect = (tillId) => {
//     console.log('Selecting till with ID:', tillId);
//     selectTill(tillId);
//   };

//   // Handle logout
//   const handleLogout = () => {
//     console.log('Initiating logout');
//     sessionStorage.removeItem('tos-shops');
//     sessionStorage.removeItem('tos-selectedShop');
//     sessionStorage.removeItem('tos-selectedTill');
//     sessionStorage.removeItem('Role');
//     localStorage.clear();
//     handleLogoutUser();
//     navigate('/login');
//   };

//   // Handle navigation
//   const handleProfileNavigation = () => {
//     console.log('Navigating to profile page');
//     navigate('/employees/profile');
//   };

//   const handleDailyTransactionsNavigation = () => {
//     if (!selectedTill) {
//       message.error('Please select a till before navigating');
//       return;
//     }
//     console.log('Navigating to daily transactions page');
//     navigate('/pos/dailytransactions', {
//       state: { shopId: selectedShop?.shopId, shopName: selectedShop?.shopName, businessId: selectedShop?.businessId },
//     });
//   };

//   const handlePOSNavigation = () => {
//     if (!selectedTill) {
//       message.error('Please select a till before navigating');
//       return;
//     }
//     console.log('Navigating to POS page');
//     navigate('/pos/layout', {
//       state: { shopId: selectedShop?.shopId, shopName: selectedShop?.shopName, businessId: selectedShop?.businessId },
//     });
//   };
//   const handleRefresh = () => {
//     console.log('Refreshing page');
//     window.location.reload();
//   };
//   return (
//     <>
//       <nav className="nav navbar navbar-expand-xl navbar-light iq-navbar">
//         <div className="container-fluid navbar-inner">
//           <a href="/#/pos/layout" className="navbar-brand">
//             <span className="brand-name">POS Dashboard</span>
//           </a>

//           <div className="d-flex gap-4 align-items-center">
//             {/* Shop Dropdown */}
//             <Spin spinning={shopLoading}>
//               <Select
//                 showSearch
//                 placeholder="Select a shop"
//                 optionFilterProp="children"
//                 onChange={handleShopSelect}
//                 value={selectedShop?.shopId}
//               //  disabled={isPosOperator || shopLoading}
//                 style={{ width: 250 }}
//                 notFoundContent="No shops available"
//               >
//                 {shops.map((shop) => (
//                   <Select.Option key={shop.shopId} value={shop.shopId}>
//                     {shop.shopName}
//                   </Select.Option>
//                 ))}
//               </Select>
//             </Spin>

//             {/* Till Dropdown */}
//             {isPosOperator && selectedShop && (
//               <Spin spinning={tillLoading}>
//                 <Select
//                   showSearch
//                   placeholder="Select a till"
//                   optionFilterProp="children"
//                   onChange={handleTillSelect}
//                   value={selectedTill?.till.id}
//                   // disabled={tillLoading || !selectedShop}
//                   style={{ width: 250 }}
//                   notFoundContent="No tills available"
//                 >
//                   {tills.map((assignment) => (
//                     <Select.Option key={assignment.till.id} value={assignment.till.id}>
//                       {assignment.till.name}
//                     </Select.Option>
//                   ))}
//                 </Select>
//               </Spin>
//             )}

//                <li class="nav-item dropdown" onClick={handleRefresh}>
//                     <a href="#" className="nav-link" >
//                  <svg
//               width="20"
//               height="20"
//               viewBox="0 0 24 24"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58 4 4.01 7.58 4.01 12C4.01 16.42 7.58 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z"
//                 fill="currentColor"
//               ></path>
//             </svg>
//                                     <span class="bg-danger dots"></span>
//                                 </a>
//                                 <div class="p-0 sub-drop dropdown-menu dropdown-menu-end" aria-labelledby="notification-drop">
                                   
//                                 </div>
//                             </li>
//           </div>

//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarSupportedContent"
//             aria-controls="navbarSupportedContent"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon">
//               <span className="mt-2 navbar-toggler-bar bar1"></span>
//               <span className="navbar-toggler-bar bar2"></span>
//               <span className="navbar-toggler-bar bar3"></span>
//             </span>
//           </button>

//           <div className="collapse navbar-collapse" id="navbarSupportedContent">
//             <ul className="mb-2 navbar-nav ms-auto align-items-center navbar-list mb-lg-0">
//               <li className="nav-item dropdown custom-drop">
//                 <a
//                   className="py-0 nav-link d-flex align-items-center"
//                   href="#"
//                   id="navbarDropdown"
//                   role="button"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                 >
//                   <UserSwitchOutlined style={{ fontSize: '25px', color: '#08c' }} />
//                 </a>
//                 <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
//                   <li>
//                     <a className="dropdown-item" onClick={handlePOSNavigation}>
//                       POS
//                     </a>
//                   </li>
//                   <li>
//                     <a className="dropdown-item" onClick={handleDailyTransactionsNavigation}>
//                       Daily Transaction
//                     </a>
//                   </li>
//                   <li>
//                     <a className="dropdown-item" onClick={handleProfileNavigation}>
//                       Profile
//                     </a>
//                   </li>
//                   <li>
//                     <hr className="dropdown-divider" />
//                   </li>
//                   <li>
//                     <a className="dropdown-item" onClick={handleLogout}>
//                       Logout
//                     </a>
//                   </li>
//                 </ul>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>

//       <div className="iq-navbar-header" style={{ height: '50px', backgroundImage: `url(${tobImage})` }}>
//         <div className="container-fluid iq-container">
//           <div className="row">
//             <div className="col-md-12">
//               <div className="flex-wrap d-flex justify-content-between align-items-center">
//                 <div>
//                   {/* <h4 className="font-size-24">
//                     Hello, {selectedShop?.shopName || 'No Shop'} {selectedTill ? `| Till: ${selectedTill.till.name}` : ''} 
//                     {selectedShop?.businessId ? `| Business ID: ${selectedShop.businessId}` : ''}
//                   </h4> */}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default RolePosTopbar;


import React, { useEffect, useState } from 'react';
import { UserSwitchOutlined } from '@ant-design/icons';
import { useAuthContext } from '../../components/AuthProvider'; // Adjust path
import { usePosOperatorShop } from '../../components/api/usePosOperatorShopid'; 
import { useTillContext } from '../../components/tillContext'; // Adjust path
import { useNavigate } from 'react-router-dom';
import { Select, message, Spin, Form } from 'antd';
import 'antd/dist/reset.css'; // For Ant Design v5
import tobImage from '../../assets/images/top-header.png';

function RolePosTopbar() {
  const { handleLogoutUser, token, loginRole, userId } = useAuthContext();
  const { shops, selectedShop, selectShop, loading: shopLoading, error: shopError } = usePosOperatorShop();
  const { tills, selectedTill, selectTill, loading: tillLoading, error: tillError } = useTillContext();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const isPosOperator = loginRole.includes('POS Operator');

  // Handle errors
  useEffect(() => {
    if (shopError) {
      message.error(`Failed to fetch shops: ${shopError}`);
    }
    if (tillError) {
      // message.error(`Failed to fetch tills: ${tillError}`);
    }
    // Log businessId for debugging
    console.log('Selected Shop:', selectedShop);
    console.log('Selected Shop businessId:', selectedShop?.businessId || 'Not available');
  }, [shopError, tillError, selectedShop]);

  // Handle shop selection
  const handleShopSelect = (shopId) => {
    console.log('Selecting shop with ID:', shopId);
    selectShop(shopId);
  };

  // Handle till selection
  const handleTillSelect = (tillId) => {
    console.log('Selecting till with ID:', tillId);
    selectTill(tillId);
  };

  // Handle logout
  const handleLogout = () => {
    console.log('Initiating logout');
    sessionStorage.removeItem('tos-shops');
    sessionStorage.removeItem('tos-selectedShop');
    sessionStorage.removeItem('tos-selectedTill');
    sessionStorage.removeItem('Role');
    localStorage.clear();
    handleLogoutUser();
    navigate('/login');
  };

  // Handle navigation
  const handleProfileNavigation = () => {
    console.log('Navigating to profile page');
    navigate('/employees/profile');
  };

  const handleDailyTransactionsNavigation = () => {
    if (!selectedTill) {
      message.error('Please select a till before navigating');
      return;
    }
    console.log('Navigating to daily transactions page');
    navigate('/pos/dailytransactions', {
      state: { shopId: selectedShop?.shopId, shopName: selectedShop?.shopName, businessId: selectedShop?.businessId },
    });
  };

  const handlePOSNavigation = () => {
    if (!selectedTill) {
      message.error('Please select a till before navigating');
      return;
    }
    console.log('Navigating to POS page');
    navigate('/pos/layout', {
      state: { shopId: selectedShop?.shopId, shopName: selectedShop?.shopName, businessId: selectedShop?.businessId },
    });
  };
  
  const handleRefresh = () => {
    console.log('Refreshing page');
    window.location.reload();
  };
  
  return (
    <>
      <style>
        {`
          /* Mobile Responsive Styles */
          @media (max-width: 768px) {
            .navbar-inner {
              flex-wrap: wrap !important;
              gap: 10px !important;
            }
            
            .navbar-brand {
              order: 1;
              margin-right: auto !important;
            }
            
            .d-flex.gap-4 {
              order: 2;
              gap: 8px !important;
              width: 100%;
              flex-wrap: wrap;
            }
            
            .d-flex.gap-4 .ant-select {
              flex: 1;
              min-width: 0;
            }
            
            .d-flex.gap-4 .ant-select .ant-select-selector {
              font-size: 12px !important;
            }
            
            .navbar-toggler {
              order: 3;
              display: block !important;
            }
            
            .collapse.navbar-collapse {
              order: 4;
              width: 100%;
            }
            
            .iq-navbar-header {
              height: 60px !important;
              background-size: cover;
              background-position: center;
            }
            
            .nav-link {
              padding: 8px 12px !important;
            }
            
            .dropdown-menu {
              position: absolute !important;
              min-width: 160px !important;
            }
            
            /* Make selects full width on mobile */
            .ant-select {
              width: 100% !important;
            }
            
            /* Adjust refresh icon size */
            .nav-item.dropdown svg {
              width: 18px;
              height: 18px;
            }
          }
          
          /* Tablet Styles */
          @media (min-width: 769px) and (max-width: 1024px) {
            .d-flex.gap-4 {
              gap: 12px !important;
            }
            
            .ant-select {
              width: 200px !important;
            }
          }
          
          /* Desktop Styles (default) */
          @media (min-width: 1025px) {
            .navbar-toggler {
              display: none !important;
            }
          }
        `}
      </style>
      
      <nav className="nav navbar navbar-expand-xl navbar-light iq-navbar">
        <div className="container-fluid navbar-inner">
          <a href="/#/pos/layout" className="navbar-brand">
            <span className="brand-name">POS Dashboard</span>
          </a>

          <div className="d-flex gap-4 align-items-center">
            {/* Shop Dropdown */}
            <Spin spinning={shopLoading}>
              <Select
                showSearch
                placeholder="Select a shop"
                optionFilterProp="children"
                onChange={handleShopSelect}
                value={selectedShop?.shopId}
                style={{ width: 250 }}
                notFoundContent="No shops available"
              >
                {shops.map((shop) => (
                  <Select.Option key={shop.shopId} value={shop.shopId}>
                    {shop.shopName}
                  </Select.Option>
                ))}
              </Select>
            </Spin>

            {/* Till Dropdown */}
            {isPosOperator && selectedShop && (
              <Spin spinning={tillLoading}>
                <Select
                  showSearch
                  placeholder="Select a till"
                  optionFilterProp="children"
                  onChange={handleTillSelect}
                  value={selectedTill?.till.id}
                  style={{ width: 250 }}
                  notFoundContent="No tills available"
                >
                  {tills.map((assignment) => (
                    <Select.Option key={assignment.till.id} value={assignment.till.id}>
                      {assignment.till.name}
                    </Select.Option>
                  ))}
                </Select>
              </Spin>
            )}

            <li className="nav-item dropdown" onClick={handleRefresh}>
              <a href="#" className="nav-link">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58 4 4.01 7.58 4.01 12C4.01 16.42 7.58 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z"
                    fill="currentColor"
                  ></path>
                </svg>
                <span className="bg-danger dots"></span>
              </a>
              <div className="p-0 sub-drop dropdown-menu dropdown-menu-end" aria-labelledby="notification-drop">
              </div>
            </li>
          </div>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <span className="mt-2 navbar-toggler-bar bar1"></span>
              <span className="navbar-toggler-bar bar2"></span>
              <span className="navbar-toggler-bar bar3"></span>
            </span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="mb-2 navbar-nav ms-auto align-items-center navbar-list mb-lg-0">
              <li className="nav-item dropdown custom-drop">
                <a
                  className="py-0 nav-link d-flex align-items-center"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <UserSwitchOutlined style={{ fontSize: '25px', color: '#08c' }} />
                </a>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                  <li>
                    <a className="dropdown-item" onClick={handlePOSNavigation}>
                      POS
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" onClick={handleDailyTransactionsNavigation}>
                      Daily Transaction
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" onClick={handleProfileNavigation}>
                      Profile
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" onClick={handleLogout}>
                      Logout
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="iq-navbar-header" style={{ height: '50px', backgroundImage: `url(${tobImage})` }}>
        <div className="container-fluid iq-container">
          <div className="row">
            <div className="col-md-12">
              <div className="flex-wrap d-flex justify-content-between align-items-center">
                <div>
                  {/* <h4 className="font-size-24">
                    Hello, {selectedShop?.shopName || 'No Shop'} {selectedTill ? `| Till: ${selectedTill.till.name}` : ''} 
                    {selectedShop?.businessId ? `| Business ID: ${selectedShop.businessId}` : ''}
                  </h4> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RolePosTopbar;